// extracted by mini-css-extract-plugin
module.exports = {"login":"Login_login__2affY","forms":"Login_forms__4Y84d"};